import React, { useState, useMemo } from 'react';

import { Stack, makeStyles, View } from '@gogame/components';

import SearchField from './SearchField';

const EMPTY_OPTIONS = [];
const EMPTY_VALUES = [];

const useClasses = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  lists: {
    height: '100%',
    border: `1px solid ${theme.palette.divider}`,
  },
}));

const ApplicationREs = ({
  children,
  data,
  values = EMPTY_VALUES,
  onChange,
  loading,
  availableLabel,
  selectedLabel,
}) => {
  const classes = useClasses();

  const [searchQuery, setSearchQuery] = useState('');

  const filteredOptions = useMemo(() => {
    return searchQuery
      ? data?.filter(({ name }) => {
          return name
            .toLocaleLowerCase()
            .includes(searchQuery.toLocaleLowerCase());
        })
      : data;
  }, [data, searchQuery]);

  const handleChangeSearchQuery = (query) => setSearchQuery(query);

  const handleChange = (value) => {
    onChange({}, value);
  };

  return (
    <Stack spacing={3} className={classes.root}>
      <SearchField value={searchQuery} onChange={handleChangeSearchQuery} />
      <View loading={loading} className={classes.lists}>
        {children({
          options: data || EMPTY_OPTIONS,
          filteredOptions: filteredOptions || EMPTY_OPTIONS,
          value: values,
          onChange: handleChange,
          searchQuery: searchQuery,
          availableLabel,
          selectedLabel,
        })}
      </View>
    </Stack>
  );
};

export default ApplicationREs;
